module.exports = __webpack_public_path__ + "static/media/vehicle_in_out_1.434b259a.png";